fragment DripSequenceDashboardFragment on RecentDrip {
    edition {
        id
        name
        htmlUrlPath
    }
    formattedDeliveries
    formattedOpenRate
    formattedClickRate
}
